<template>
  <div class="createPro-box">
    <div class="createProLeft"></div>
    <div class="createProRight">
      <div id="createpro">
    <p class="title">创建产品</p>
      <div style="padding: 20px 30px;">
        <el-form ref="form" label-width="100px" id="form" :model="dataTable" :rules="dataVerification">
          <el-form-item label="产品名称" prop="client_name">
            <el-tooltip content="请输入产品名称,2~50个汉字、英文" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input placeholder="请输入产品名称,2~50个汉字、英文" v-model.trim="dataTable.client_name" @blur="checkName"></el-input>
          </el-form-item>
          <el-form-item label="产品类型">
            <el-button type="default" class="little-btn" size="mini" round :class="dataTable.open_product_type == '智能音箱' ? 'btnActive' : null" @click="productType(0)">智能音箱</el-button>
            <el-button type="default" class="little-btn" size="mini" round :class="dataTable.open_product_type == '智能电视' ? 'btnActive' : null" @click="productType(1)">智能电视</el-button>
            <el-button type="default" class="little-btn" size="mini" round :class="(dataTable.open_product_type != '智能音箱' && dataTable.open_product_type != '智能电视') ? 'btnActive' : null" @click="productType(2)">自定义</el-button>
            <el-input class="proTypeInput" placeholder="请输入产品类型" v-show="dataTable.open_product_type != '智能音箱' && dataTable.open_product_type != '智能电视'" v-model.trim="dataTable.open_product_type"></el-input>
          </el-form-item>
            <el-form-item label="支持系统">
              <img src="../../../static/images/android.png" alt="安卓" style="width: 60px">
            </el-form-item>
            <el-form-item label="产品简介" prop="open_product_intro">
              <el-tooltip content="简单介绍您的产品, 20~500字符" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
            <el-input type="textarea" placeholder="简单介绍您的产品, 20~500字符" :autosize="{ minRows: 4, maxRows: 9}" v-model.trim="dataTable.open_product_intro"></el-input>
            </el-form-item>
        </el-form>
      </div>
    <el-button type="primary" round class="intentSavebtn complete" size="mini" @click="createProduct">完成</el-button>
  </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { createProApi, checkProApi } from "@/api/hardIndex.js";
export default {
  data() {
    var checkChinese = (rule, value, callback) => {
      setTimeout(() => {
        var reg = new RegExp("^[\u4e00-\u9fa5a-zA-Z]+$");
        if (!reg.test(value)) {
//            this.$message.error('请输入正确的字典名，2~50个汉字')
          callback(new Error('请填写产品名称，并在2~50个汉字、英文!'));
        } else {
          callback();
        }
      }, 100);
    }
    return {
      dataTable: {
        client_name: "",
        open_product_type: "智能电视",
        open_product_intro: "",
        open_os_type: 1 // 1安卓,2ios
      },
      dataVerification: {
        client_name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 50 个汉字、英文", trigger: "blur" },
          {validator: checkChinese, trigger: 'blur'}
        ],
        open_product_intro: [
          { required: true, message: "请输入产品简介", trigger: "blur" },
          {
            min: 20,
            max: 500,
            message: "长度在 20 到 500 个字符",
            trigger: "blur"
          }
        ]
      },
      tabindexNum: "-1"
    };
  },
  created() {
    this.tabindexNumChange();
  },
  methods: {
    productType(type) {
      switch (type) {
        case 0:
          this.dataTable.open_product_type = "智能音箱";
          break;
        case 1:
          this.dataTable.open_product_type = "智能电视";
          break;
        case 2:
          this.dataTable.open_product_type = "";
          break;
      }
    },
    //产品名称查重
    async checkName() {
      if (this.dataTable.client_name == "") return;
      let res = await checkProApi(
        qs.stringify({ client_name: this.dataTable.client_name })
      );
      if (res.data.code != 200) {
        this.$message({ message: res.data.errors.data, type: "error" });
        return;
      }
    },
    async createProduct() {
      this.$refs.form.validate((valid) => {
        if (valid) {

        } else {
          this.$root.scroll_top();
          return false;
        }
      });
      let regProductName = /[^\u4e00-\u9fa5a-zA-Z]/g;
      if (
        regProductName.test(this.dataTable.client_name) ||
        this.dataTable.client_name == "" ||
        this.dataTable.client_name.length < 2 ||
        this.dataTable.client_name.length > 50
      ) {
//        this.$message.error("请填写产品名称，并在2~50个汉字!");
        return;
      }
      if (
        this.dataTable.open_product_intro == "" ||
        this.dataTable.open_product_intro.length < 20 ||
        this.dataTable.open_product_intro.length > 500
      ) {
//        this.$message.error("请填写产品简介，并在20~500个字符!");
        return;
      }
      if (this.dataTable.open_product_type == "") {
        this.$message.error("请选择产品类型!");
        return;
      }
      let da = await checkProApi(
        qs.stringify({ client_name: this.dataTable.client_name })
      );
      if (da.data.code != 200) {
        this.$message({ message: da.data.errors.data, type: "error" });
        return;
      }
      /*    if (this.dataTable.open_product_intro == '') {
          this.$message.error('请填写产品简介，长度在20~500字符之间!')
          return
        }*/
      let res = await createProApi(qs.stringify(this.dataTable));
      if (res.data.code == 200) {
        this.$message.success("创建成功");
        this.$router.push("/productList");
        //          console.log(res)
      } else {
        this.$message.error("当前网络状况异常，请稍后再试");
      }
    },
    tabindexNumChange() {
      this.tabindexNum = "-1";
    }
  }
};
</script>
<style  rel="stylesheet/scss" lang="scss">
.createPro-box {
  position: relative;
  width: 100%;
  height: 100%;
  .createProLeft {
    position: fixed;
    left: 0;
    top: 60px;
    margin-top: 27px;
    bottom: 0;
    width: 200px;
    background: #fff url("../../../static/images/createProLeft.png") no-repeat
      center top;
  }
  .createProRight {
    position: absolute;
    left: 230px;
    right: 0;
    margin-top: 27px;
    top: 60px;
    height: 100%;
    background: #fff;
  }
}
#createpro {
  background: #fff;
  overflow: hidden;
  #form {
    .el-input__inner {
      width: 220px;
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
    }
    .el-textarea__inner {
      width: 80%;
      border-radius: 14px;
    }
  }
  .complete {
    margin-left: 45%;
  }
  .btnActive {
    background: #409eff;
    color: #fff;
    border: 1px solid #409eff;
  }
  .proTypeInput {
    position: absolute;
    margin-left: 10px;
    margin-top: 1px;
  }
  .title {
    height: 64px;
    line-height: 64px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: 900;
    color: #2e4d79;
    border-bottom: 1px solid #f5f5f5;
    border-left: 2px solid #010202;
  }
  .little-btn {
    height: 28px;
    line-height: 8px;
  }
  .el-form-item {
    position: relative;
    .blurIcon {
      color: #7abaf1;
      position: absolute;
      left: -18px;
    }
  }
  .el-form-item__label {
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hardware/CreatePro.vue